<template>
  <div class="holiday-rule-root" :class="{ 'no-sort': !(prize1 && prize1.rank) }">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" :title="$t('lang.commonM.k111')" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="bg-block">
      <!-- Event window -->
      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k230') }}</div>
        <div class="item-txt" v-if="actStartTime && actEndTime">
          1. {{ $t('lang.commonM.k231') }}:
          <br />
          <i style="color: #ff9524">{{ actStartTime }} - {{ actEndTime }}</i>
        </div>
        <div class="item-txt">2. {{ $t('lang.commonM.k251') }}</div>
      </div>

      <!-- How to earn points -->
      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k233') }}</div>
        <div class="item-txt">1. {{ $t('lang.commonM.k248') }}</div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Gem.png" alt="" />
            {{ $t('lang.commonM.k454') }}
          </div>
          <span>
            <i>1</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
        <div class="gift-num">
          <div>
            <img src="@/assets/packageAssets/common/Ring.png" alt="" />
            {{ $t('lang.commonM.k211') }}
          </div>
          <span>
            <i>3</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
        <div class="gift-num">
          <div>
            <img src="@/assets/packageAssets/common/Fireworks.png" alt="" />
            {{ $t('lang.commonM.k451') }}
          </div>
          <span>
            <i>7</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
        <div class="gift-num">
          <div>
            <img src="@/assets/packageAssets/common/Kiss.png" alt="" />
            {{ $t('lang.commonM.k305') }}
          </div>
          <span>
            <i>15</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
        <div class="gift-num">
          <div>
            <img src="@/assets/packageAssets/common/Candy.png" alt="" />
            {{ $t('lang.commonM.k214') }}
          </div>
          <span>
            <i>80</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
      </div>

      <!-- Leaderboard Rewards -->
      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k218') }}</div>
        <div class="item-txt">1. {{ $t('lang.commonM.k431') }}</div>
        <div class="item-txt" v-if="actEndTime">
          2. {{ $t('lang.commonM.k432') }}
          <br />
          <i style="color: #ff9524">{{ actEndTime }}</i>
        </div>
        <div class="item-txt">3. {{ $t('lang.commonM.k433') }}</div>
        <div class="reward-item" style="margin-top: 16px">
          <div class="reward-num">No.1</div>
          <div class="reward-coins">
            1000
            <img class="coins-icon" :src="getMatchImg('coin')" />
          </div>
        </div>
        <div class="reward-item">
          <div class="reward-num">No.2</div>
          <div class="reward-coins">
            700
            <img class="coins-icon" :src="getMatchImg('coin')" />
          </div>
        </div>
        <div class="reward-item">
          <div class="reward-num">No.3</div>
          <div class="reward-coins">
            500
            <img class="coins-icon" :src="getMatchImg('coin')" />
          </div>
        </div>
        <div class="reward-item">
          <div class="reward-num">No.4-10</div>
          <div class="reward-coins">
            80
            <img class="coins-icon" :src="getMatchImg('coin')" />
          </div>
        </div>
      </div>

      <!-- Important notice -->
      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k201') }}</div>
        <div class="item-txt">1. {{ $t('lang.commonM.k434') }}</div>
        <div class="item-txt">2. {{ $t('lang.commonM.k204') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { holidayActBaseInfo } from './apidir/api.js'

export default {
  data() {
    return {
      actStartTime: '',
      actEndTime: ''
    }
  },
  methods: {
    // 获取数据
    fetchData() {
      holidayActBaseInfo().then((resData) => {
        if (resData && !resData.error) {
          if (resData.startTimestamp) {
            this.actStartTime = this.handleMoment(resData.startTimestamp, 'YYYY-MM-DD HH:mm:ss')
          }
          if (resData.endTimestamp) {
            this.actEndTime = this.handleMoment(resData.endTimestamp, 'YYYY-MM-DD HH:mm:ss')
          }
        }
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.holiday-rule-root {
  width: 100%;
  min-height: calc(100vh - 150px);
  background: #fc3c3b url(./images/rules-bg.png) top left / 100% auto no-repeat;

  .custom-nav-block {
    background: url(./images/rules-bg.png) top left / 100% auto no-repeat;
  }

  .bg-img {
    width: 100%;
  }

  .bg-block {
    position: relative;
    min-height: 100vh;

    padding: 35px 10px;

    .item-block {
      width: 100%;
      padding: 16px;
      margin-bottom: 16px;
      border-radius: 12px;
      background: #fffcf0;

      .item-tit {
        line-height: 22px;
        font-family: TikTokSans-Regular;
        font-weight: bold;
        font-size: 17px;
        color: #af2f3a;
        line-height: 22px;
      }

      .item-txt {
        width: 323px;
        line-height: 22px;
        font-family: TikTokSans-Regular;
        font-size: 15px;
        color: #be2a32;
        margin-top: 8px;
      }

      .item-tip-b {
        color: #ff9524;
        font-family: TikTokSans-Regular;
        font-size: 17px;
        font-weight: 700;
        margin-top: 8px;
        // i {
        //   color: #292d59;
        //   font-family: Roboto Flex;
        //   font-size: 17px;
        //   font-weight: 400;
        // }
      }

      .item-tip-r {
        color: #292d59;
        font-family: TikTokSans-Regular;
        font-size: 15px;
        font-weight: 600;
        margin-top: 8px;
      }

      .gift-num {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
        > div {
          display: flex;
          align-items: center;
          gap: 10px;

          font-family: TikTokSans-Regular;
          font-weight: 400;
          font-size: 17px;
          color: #be2a32;
          line-height: 20px;

          img {
            width: 24px;
            height: 24px;
          }
        }
        > span {
          font-family: TikTokSans-Regular;
          font-weight: 400;
          font-size: 17px;
          color: #be2a32;
          line-height: 20px;
          text-align: right;
          i {
            color: #ffba3b;
            font-weight: bold;
          }
        }
      }

      .reward-item {
        font-family: TikTokSans-Regular;
        font-weight: 400;
        font-size: 15px;
        color: #be2a32;
        line-height: 20px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        .reward-coins {
          display: flex;
          align-items: center;
          font-weight: bold;
          .coins-icon {
            width: 16px;
            height: 16px;
            margin-left: 4px;
          }
        }
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: Inter-Regular;
  font-weight: 600;
  color: #ffffff;
}
::v-deep .van-nav-bar__right .tit-right {
  line-height: 16px !important;
}
</style>
